module.exports = __webpack_public_path__ + "img/baidu.59c930f4.png";